import { FORM_ELEMENT_TYPES } from '../newFormElement';
import { getFlowElement } from '../utils/getFlowElement';
export const getFlowElementProps = (element) => {
    const { elementType, title, description, optionsGroup, items, config } = element;
    const required = element.required || config?.required;
    switch (elementType) {
        case FORM_ELEMENT_TYPES.NUMBER:
        case FORM_ELEMENT_TYPES.TEXT_AREA:
        case FORM_ELEMENT_TYPES.PARTITION_RESOURCES:
            return { title, description, ...config, required };
        case FORM_ELEMENT_TYPES.DATE:
            return { title, description, ...config, required, min: config?.min ? new Date(config.min) : undefined, max: config?.max ? new Date(config.max) : undefined };
        case FORM_ELEMENT_TYPES.PHONE_NUMBER:
        case FORM_ELEMENT_TYPES.CHECKBOX:
            return { title, description, ...config, required };
        case FORM_ELEMENT_TYPES.TITLE:
            return { title };
        case FORM_ELEMENT_TYPES.INSTRUCTIONS:
            return { description };
        case FORM_ELEMENT_TYPES.TOGGLE:
        case FORM_ELEMENT_TYPES.MULTISELECT:
        case FORM_ELEMENT_TYPES.SELECT_PARTITION:
        case FORM_ELEMENT_TYPES.SELECT:
            return { title, description, optionsGroup, items, ...config, required };
        case FORM_ELEMENT_TYPES.SPACE:
        case FORM_ELEMENT_TYPES.DIVIDER:
            return {};
        case FORM_ELEMENT_TYPES.PREVIEW:
            return { title, description, ...config, items };
        default:
            return { title, description, ...config, required };
    }
};
export const getExamplePreviewItems = (element, call) => {
    if (element.elementType !== FORM_ELEMENT_TYPES.PREVIEW)
        return [];
    const { config } = element;
    const previewIds = config?.previewIds || [];
    if (element?.items?.length)
        return element.items;
    if (!call) {
        return previewIds.map((id) => ({
            owner: 'Assignment owner',
            datas: [{ id, name: String(id), element_type: '', values: [''] }],
        }));
    }
    const stepOrder = [];
    const byStep = new Map();
    for (const id of previewIds) {
        const { step, form, element: el, groupElement } = getFlowElement(call, id);
        if (!el)
            continue;
        const stepId = step?.id ?? -1;
        if (!byStep.has(stepId)) {
            stepOrder.push(stepId);
            byStep.set(stepId, { step, formOrder: [], byForm: new Map() });
        }
        const stepGroup = byStep.get(stepId);
        const formId = form?.id ?? -1;
        if (!stepGroup.byForm.has(formId)) {
            stepGroup.formOrder.push(formId);
            stepGroup.byForm.set(formId, { form, entries: [] });
        }
        const isGroupChild = !!groupElement && groupElement.id !== el.id;
        stepGroup.byForm.get(formId).entries.push({
            id,
            name: el.title || String(id),
            element_type: el.elementType || '',
            values: [''],
            indent: isGroupChild ? 3 : 2,
        });
    }
    return stepOrder.map((stepId) => {
        const { step, formOrder, byForm } = byStep.get(stepId);
        const datas = [];
        if (step?.title) {
            datas.push({ id: `step-${stepId}`, name: step.title, element_type: '', values: [], isSection: true, indent: 0 });
        }
        for (const formId of formOrder) {
            const { form, entries } = byForm.get(formId);
            if (form?.title) {
                datas.push({ id: `form-${formId}`, name: form.title, element_type: '', values: [], isSection: true, indent: 1 });
            }
            datas.push(...entries);
        }
        return { owner: 'Assignment owner', datas };
    });
};
